import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaMapMarkerAlt, FaMotorcycle, FaShieldAlt } from 'react-icons/fa';

const GPSPermissionModal = ({ show, onRequestPermission, onDeny }) => {
  return (
    <Modal show={show} onHide={onDeny} centered backdrop="static" size="sm">
      <div style={{ borderRadius: 20, overflow: 'hidden', border: 'none' }}>
        <div style={{
          background: 'linear-gradient(135deg, var(--bry-accent) 0%, #CC2600 100%)',
          padding: '32px 24px 24px',
          textAlign: 'center',
          color: 'var(--bry-text-main)'
        }}>
          <div style={{
            width: 64, height: 64, borderRadius: '50%',
            background: 'rgba(255,255,255,0.2)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px',
          }}>
            <FaMapMarkerAlt size={28} />
          </div>
          <h5 style={{ fontWeight: 800, marginBottom: 8, fontSize: 18 }}>
            Activa tu Ubicación
          </h5>
          <p style={{ opacity: 0.9, fontSize: 13, margin: 0, lineHeight: 1.5 }}>
            Necesitamos acceso a tu ubicación para mostrarte conductores cercanos y conectarte con ellos.
          </p>
        </div>

        <div style={{ padding: '20px 24px 24px' }}>
          <div style={{
            background: '#FFF5F3', borderRadius: 12,
            padding: '12px 16px', marginBottom: 20,
            display: 'flex', alignItems: 'center', gap: 12,
            fontSize: 12, color: '#721C24', border: '1px solid #FFE0D6'
          }}>
            <FaShieldAlt size={16} color="var(--bry-accent)" style={{ flexShrink: 0 }} />
            <span>Tu ubicación solo se usa mientras la app está abierta. Nunca compartimos tus datos sin tu permiso.</span>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <Button
              onClick={onRequestPermission}
              style={{
                background: 'var(--bry-accent)', border: 'none', borderRadius: 12,
                fontWeight: 700, fontSize: 15, padding: '12px',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8
              }}
            >
              <FaMotorcycle />
              Activar Ubicación
            </Button>
            <Button
              variant="light"
              onClick={onDeny}
              style={{
                borderRadius: 12, fontWeight: 600, fontSize: 14,
                background: '#F5F5F5', border: 'none', color: '#666',
                padding: '10px'
              }}
            >
              Ahora no
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default GPSPermissionModal;
